import env from './env';
import { hijackJumpInJM } from '@zero/acore-in-jm';

// 如果在iframe下
if (window.parent !== window)
  document.body?.classList?.add('acore-in-jm')

hijackJumpInJM({env});